import { Box, Button, IconButton, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Props } from '../interface'

import { Ref, createRef, forwardRef, useImperativeHandle, useMemo, useState } from 'react'
import { useStyles } from './styles'
import { icons } from '../../../../../../../../../../utils/icons'
import StepperCreate from '../../../../../../../../../../components/stepperCreate'
import { Step1 } from '../step1'
import { Step2 } from '../step2'
import { ArrowBack } from '../../../../../../../../../../components/arrowBack'
import { LoadingButton } from '@mui/lab'
import { SnackSimple } from '../../../../../../../../../../components'


const AgentSteps = forwardRef((props: Props/* , ref: Ref<StepsRef> */) => {
    const styles = useStyles()

    const { t } = useTranslation()

    const lastStep = [1].includes(props.steps ?? 0)

    const CurrentStep = () => {
        switch (props.steps) {
            case 0:
                return <Step1 /* colors={props.color} */ {...props.step1} />
            case 1:
                return <Step2 /* colors={props.color} */ {...props.step2} />
            case 2:
                return (
                    <Box sx={styles.containerFinal}>
                        <Typography sx={styles.icon}>{icons('check-outlined')}</Typography>
                        <Typography variant='big' fontWeight='medium-bold'>{t('loogbook.titles.allActivitiesCreated')}</Typography>
                        <Button onClick={() => { window.location.hash = '' }} className="continue" variant="contained" >
                                {t('loogbook.buttons.continue')}
                            </Button>
                    </Box>
                )
            default:
                return null
        }

    }

    const stepBack = () => {
        props.handleSteps(-1)
    }

    const stepForward = () => {
        props.handleSteps(1)
    }

    const disabled = () => {
        if (props.steps == 0) {
            return props.step1.disable
        }
        if (props.steps == 1) {
            return props.step2.disable
        }

        return false
    }

    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <Box sx={styles.headerLeft}>
                    <ArrowBack
                        label={t("general.goBackToTheList")}
                        arrowProps={{ sx: styles.arrow, onClick: () => { window.location.hash = '' } }}
                    />
                    <Typography sx={styles.title}>{t('loogbook.titles.createActivity')}</Typography>
                </Box>



                <Box sx={styles.stepper}>
                    <StepperCreate color={props.color} steps={props.stepsArray} activeStep={props.activeStep} />
                </Box>
            </Box>

            <Box sx={styles.body}>{CurrentStep()}</Box>

            <Box sx={styles.buttonsContainer(!props.isParnert)}>
                {!props.steps && <Button onClick={() => { window.location.hash = '' }}>{t('general.cancel')}</Button>}
                {props.steps == 1 && !props.isParnert && <Button onClick={stepBack}>{t('general.return')}</Button>}

                {!props.steps &&
                    <Button disabled={disabled()} className="next" variant="contained" onClick={stepForward}>
                        {t('general.continue')}
                    </Button>
                }
                {props.steps == 1 &&
                    <LoadingButton loading={props.step1.loading.subtmitActivity} disabled={disabled()} className="next" variant="contained" onClick={props.handleSubmitActivities}>
                        {t('general.assigned')}
                    </LoadingButton>
                }

            </Box>

            <SnackSimple
                close={props.closeSnackbar}
                open={props.snackbar?.open}
                type={props.snackbar?.type}
                message={props.snackbar?.message}
            />
        </Box>
    )
})

export { AgentSteps }